/**
 * Header UI 클래스
 * 헤더와 관련된 UI 상호작용(모바일 메뉴 토글, 네비게이션 링크 활성화 등)을 관리합니다.
 */
class Header {
  /**
   * 헤더 모듈을 초기화합니다.
   * 필요한 모든 이벤트 리스너를 등록합니다.
   */
  init() {
    this.initializeMobileMenuToggle();
    this.initializeLanguageSelector();
    // activateNavLinks는 페이지 언어 및 URL이 확정된 후 app-core.js에서 직접 호출합니다.
  }

  /**
   * 모바일 햄버거 메뉴 토글 기능을 초기화합니다.
   */
  initializeMobileMenuToggle() {
    const mobileMenuToggle = document.getElementById('mobile-menu-toggle');
    const mobileMenu = document.getElementById('mobile-menu');

    if (mobileMenuToggle && mobileMenu) {
      mobileMenuToggle.addEventListener('click', () => {
        const isOpen = mobileMenu.style.display === 'block';
        mobileMenu.style.display = isOpen ? 'none' : 'block';
        mobileMenuToggle.setAttribute('aria-expanded', String(!isOpen));
      });

      // 화면 크기가 변경되어 PC 뷰로 전환될 때 모바일 메뉴를 숨깁니다.
      window.addEventListener('resize', () => {
        if (window.innerWidth >= 768) {
          mobileMenu.style.display = 'none';
          mobileMenuToggle.setAttribute('aria-expanded', 'false');
        }
      });
    }
  }

  /**
   * 언어 선택 드롭다운 메뉴 토글 기능을 초기화합니다.
   */
  initializeLanguageSelector() {
    const toggleButton = document.getElementById('language-toggle');
    const menu = document.getElementById('language-menu');

    if (toggleButton && menu) {
      toggleButton.addEventListener('click', (event) => {
        event.stopPropagation();
        menu.classList.toggle('hidden');
      });

      document.addEventListener('click', (event) => {
        if (!menu.contains(event.target) && !toggleButton.contains(event.target)) {
          menu.classList.add('hidden');
        }
      });

      // 언어 항목 클릭 이벤트 위임
      menu.addEventListener('click', (event) => {
        const langOption = event.target.closest('.lang-option');
        if (langOption && langOption.dataset.lang) {
          event.preventDefault();
          const code = langOption.dataset.lang;
          if (window.FileToQR && window.FileToQR.i18n) {
            window.FileToQR.i18n.setLanguage(code);
            // 언어 변경 후 전체 UI 재렌더링 (app-core.js에서 languageChanged 이벤트 수신 시 renderCommonUI 호출)
          }
          menu.classList.add('hidden');
        }
      });
    }
  }

  /**
   * 현재 페이지 URL을 기반으로 네비게이션 링크에 'active' 클래스를 추가합니다.
   * app-core에서 i18n 초기화 후 호출됩니다.
   */
  activateNavLinks() {
    // PageManager가 window.FileToQR에 할당되기를 기다립니다.
    // TODO: 더 나은 의존성 주입 방식을 고려해야 합니다.
    setTimeout(() => {
        if (!window.FileToQR || !window.FileToQR.pageManager) {
            console.warn('[Header] PageManager is not available to activate nav links.');
            return;
        }

        const currentPath = window.location.pathname;
        const navLinks = document.querySelectorAll('header nav a.nav-link');

        navLinks.forEach(link => {
            const i18nUrlKey = link.dataset.i18nUrl;
            link.classList.remove('active');
            link.removeAttribute('aria-current');

            if (i18nUrlKey) {
                const pageMapEntry = window.FileToQR.pageManager.getPageMapEntryByI18nKey(i18nUrlKey);
                if (pageMapEntry && pageMapEntry.path) {
                    const targetFileName = pageMapEntry.path.substring(pageMapEntry.path.lastIndexOf('/') + 1);
                    const currentFileName = currentPath.substring(currentPath.lastIndexOf('/') + 1) || 'index.html';

                    if (currentFileName === targetFileName) {
                        link.classList.add('active');
                        link.setAttribute('aria-current', 'page');
                    }
                }
            }
        });
    }, 100); 
  }
}

export default Header; 